import { useEffect, useLayoutEffect, useRef, useState } from "react";

export const useDimensions = (targetRef: React.RefObject<HTMLDivElement>) => {

    const getDimensions = () => {
      return {
        width: targetRef.current ? targetRef.current.offsetWidth : 0,
        height: targetRef.current ? targetRef.current.offsetHeight : 0
      };
    };
  
    const [dimensions, setDimensions] = useState(getDimensions);
    const handleResizeRef = useRef(() => setDimensions(getDimensions()));
    handleResizeRef.current = () => setDimensions(getDimensions());
  
    useEffect(() => {
      const handler = () => handleResizeRef.current();
      window.addEventListener("resize", handler);

      let ro: ResizeObserver | undefined;
      if (targetRef.current) {
        ro = new ResizeObserver(handler);
        ro.observe(targetRef.current);
      }

      return () => {
        window.removeEventListener("resize", handler);
        ro?.disconnect();
      };
    }, []);
  
    useLayoutEffect(() => {
      handleResizeRef.current();
    }, []);
  
    return dimensions;
  }